<template lang="pug">
  .breadcrumbs(v-if="list.length")
    div.breadcrumbs__mobile
      portal(to="breadcrumbs")
        .breadcrumbs.breadcrumbs__seo
          component.breadcrumbs__item(:is="setTag(item)" v-for="(item, i) in items" :key="i" :to="item.to || null") {{ item.title }}

    div.breadcrumbs__desktop
      component.breadcrumbs__item(:is="setTag(item)" v-for="(item, i) in items" :key="i" :to="item.to || null") {{ item.title }}
</template>

<script>
export default {
  name: 'Breadcrumbs',

  props: {
    list: {
      type: Array,
      required: true
    }
  },

  jsonld () {
    const items = this.items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.title,
      ...(item.to && { item: this.$config.WWW_HOST + item.to })
    }))

    return {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items
    }
  },

  computed: {
    items () {
      return [
        {
          title: 'Gaming-Goods',
          to: this.localeLocation('/')
        },
        ...this.list.map((item) => {
          let to = this.localeLocation(item.to)
          to = item.to ? to : this.$route.path
          return {
            ...item,
            to
          }
        })
      ]
    }
  },

  methods: {
    setTag (item) {
      return item.to ? 'NuxtLink' : 'span'
    }
  }
}
</script>

<style lang="scss">
.breadcrumbs {
  display: flex;
  font-size: 16px;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  flex-wrap: wrap;

  &__mobile {
    @media (min-width: $breakpointTablet) {
      display: none;
    }

    img {
      width: 24px;
      height: 24px;

      path {
        fill: #fff;
      }
    }
  }

  &__desktop {
    display: none;

    @media (min-width: $breakpointTablet) {
      display: block;
      width: 100%;
    }
  }

  &__item {
    @include breadcrumbs;

    display: flex;
    align-items: center;
    color: white;
    margin-bottom: 8px;

    &:not(:first-child) {
      &::before {
        content: "/";
        color: $blue-grey05;
        display: inline-block;
        margin: 0 8px;
      }
    }
  }

  span.breadcrumbs__item {
    color: #ffb200;
  }

  &__seo {
    margin: 24px 16px 0;
  }
}
</style>
